export default __webpack_public_path__ + "assets/images/ab21dfd919a788ff90d82d5d94db979c.jpg";